import { PharmacyStatusEnum, pharmacyStatusColor } from '@app/icare/entities/pharmacy/schema/Pharmacy'
import { Tag } from 'antd'
import { twMerge } from 'tailwind-merge'

interface PharmacyStatusBadgeProps {
  value?: typeof PharmacyStatusEnum.$.Type | null
  className?: string
}

function PharmacyStatusTag(props: PharmacyStatusBadgeProps) {
  const { value, className } = props

  if (!value) {
    return null
  }

  return (
    <Tag color={pharmacyStatusColor[value]} variant="outlined" className={twMerge(['mx-2 self-center', className])}>
      {PharmacyStatusEnum.$.getLabel(value)}
    </Tag>
  )
}

export default PharmacyStatusTag
